<template>
    <!-- bulma addons for a horizontal menu: 
        https://versions.bulma.io/0.7.0/documentation/elements/button/#button-addons 
    -->

    <div class="selector field has-addons">
        <p class="control">
            <span v-for="item in selectable" v-bind:key="item.value" 
                class="button" 
                v-bind:class="{'is-focused' : item.selected}"
                v-on:click="onItemClick(item)" >
                {{item.label}}
            </span>
        </p>
    </div>
</template>

<script>
export default {
    name: 'Selector',
    props: {
        value: Number,
        data: Array
    },
    data() {
        return {
            selected: null,
            selectable: []
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            this.selectable = this.data.map((item) => {
                var si = {...item};
                si.selected = this.value === item.value;
                return si;
            });
        },
        onItemClick(item) {
            this.$emit("input", item.value);
            this.$emit("change");
        }
    },
    watch: {
        "value"() {
            this.refresh();
        }
    }
}
</script>

<style scoped lang="scss">



</style>
